const config = __CONFIG__;
export default config;
